<template>
    <dash
        icon="fa fa-book"
        titulo="SOLICITAÇÕES DE CONSULTORIA"
        subTitulo="APP SEBRAE"
        @click.native="
            $router.push({
                name: 'AppSebrae_Consultorias_Fornecedor_Solicitacoes'
            })
        "
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
